CustomTC.define('modules/events',['modules/core'], function(core) {
    return {
        // trigger event
        triggerEvent: function(eventName, detail) {
            core.triggerEvent(eventName, detail);
        },
        subscribe: function(eventName, callback) {
            core.on(core.init(window), eventName, callback);
        },
        unsubscribe: function(eventName, callback) {
            core.off(core.init(window), eventName, callback);
        }
    };
});
